import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminPage = () => {
  const { logout, token } = useAuth();
  const navigate = useNavigate();

  const [manualCapacity, setManualCapacity] = useState('');
  const [manualSold, setManualSold] = useState('');

  
  const [stats, setStats] = useState(null);
  const [sold, setSold] = useState('');
  const [loading, setLoading] = useState(false);

  const [reservations, setReservations] = useState([]);
  const [actionLoading, setActionLoading] = useState(null);

  // 🔄 Her şeyi çek
  const fetchAll = async () => {
  try {
    const [s, r] = await Promise.all([
      axios.get(`${API}/event/stats`),
      axios.get(`${API}/reservations`, {
        headers: { Authorization: `Bearer ${token}` }
      })
    ]);
    setStats(s.data);
    setReservations([...r.data].reverse());
  } catch (err) {
    if (err.response?.status === 401) {
      logout();
      window.location.href = '/';
    }
  }
};

  useEffect(() => {
  if (!token) return;
  fetchAll();
}, [token]);

  // 🛠️ Manuel güncelle
  const update = async () => {
    setLoading(true);
    try {
      await axios.put(
        `${API}/event/update`,
        { sold_tickets: Number(sold) },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSold('');
      await fetchAll();
      alert('Güncellendi');
    } catch (e) {
      alert(e.response?.data?.detail || 'Hata');
    }
    setLoading(false);
  };

  // ✅ Onay
  const approve = async (id) => {
    setActionLoading(id);
    await axios.put(
      `${API}/reservations/${id}/approve`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );
    await fetchAll();
    setActionLoading(null);
  };

  // ❌ Reddet
  const reject = async (id) => {
    setActionLoading(id);
    await axios.put(
      `${API}/reservations/${id}/reject`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );
    await fetchAll();
    setActionLoading(null);
  };

  // 🚪 ÇIKIŞ (GARANTİLİ)
  const handleLogout = () => {
    logout();
    window.location.href = '/';
  };

  // 📊 Frontend hesaplanan özetler
  const approvedCount = reservations
    .filter(r => r.status === 'approved')
    .reduce((a, b) => a + b.count, 0);

  const pendingCount = reservations
    .filter(r => r.status === 'pending').length;

  const rejectedCount = reservations
    .filter(r => r.status === 'rejected').length;

  if (!stats) {
  return (
    <div className="container" style={{ marginTop: 60, textAlign: 'center' }}>
      <h2>Yükleniyor...</h2>
    </div>
  );
}

return (

    <div className="container" style={{ maxWidth: 900, marginTop: 40 }}>
      <h1>🔧 Admin Paneli</h1>

      {/* 📊 ÖZET */}
      <div className="card">
        <p>🎟️ Toplam Kapasite: {stats?.total_capacity}</p>
        <p>✅ Onaylanan Kişi: {approvedCount}</p>
        <p>⏳ Bekleyen Rezervasyon: {pendingCount}</p>
        <p>❌ Reddedilen Rezervasyon: {rejectedCount}</p>
        <p>📉 Kalan Bilet: {stats?.remaining_tickets}</p>
      </div>

      {/* 🛠️ Manuel */}
      <div className="card">
        <h3>🛠️ Manuel Satılan Bilet</h3>
        <input
          type="number"
          className="input-field"
          value={sold}
          onChange={e => setSold(e.target.value)}
          placeholder="Satılan bilet"
        />
        <button className="btn btn-primary" onClick={update} disabled={loading}>
          Güncelle
        </button>
      </div>

      {/* 📋 TÜM REZERVASYONLAR */}
      <div className="card">
        <h3>📋 Rezervasyonlar</h3>

        {reservations.length === 0 && <p>Rezervasyon yok</p>}

        {reservations.map(r => (
          <div
            key={r.id}
            style={{
              border: '1px solid #8B0000',
              padding: 12,
              marginBottom: 12,
              borderRadius: 6
            }}
          >
            <p><b>İsim:</b> {r.user_name}</p>
            <p><b>Telefon:</b> {r.user_phone}</p>
            <p><b>Kişi:</b> {r.count}</p>
            <p><b>Durum:</b> {r.status}</p>

            {r.status === 'pending' && (
              <div style={{ display: 'flex', gap: 10 }}>
                <button
                  className="btn btn-success"
                  disabled={actionLoading === r.id}
                  onClick={() => approve(r.id)}
                >
                  Onayla
                </button>
                <button
                  className="btn btn-danger"
                  disabled={actionLoading === r.id}
                  onClick={() => reject(r.id)}
                >
                  Reddet
                </button>
              </div>
            )}
          </div>
        ))}
      </div>

      <button className="btn btn-secondary" onClick={handleLogout}>
        Çıkış
      </button>
    </div>
  );
};

export default AdminPage;
